import FreshdeskWidget from './FreshdeskWidget';

export default FreshdeskWidget;
